import type { LanguageCode } from '@/i18n/languages';

/** One release's user-facing notes. The prose lives at
 *  `assets/release-notes/v<version>/<language>.md`, served from
 *  `/assets/release-notes/…` through the `public/assets` symlink. */
export interface ReleaseNotesEntry {
    /** Bare semver ('0.19.0'); the UI adds the `v`. */
    version: string;
    /** Release date, YYYY-MM-DD. */
    date: string;
    /** Languages that have a file; always includes 'en'. The client never
     *  requests an unlisted one — a missing .md can come back as the SPA
     *  index.html with a 200. */
    languages: readonly LanguageCode[];
}

/** Newest first. `bun run whats-new:draft` inserts new entries directly below
 *  the marker line; test/release-notes-manifest.test.ts keeps this list and
 *  the files on disk in step. An empty list hides every What's-new surface. */
export const RELEASE_NOTES: readonly ReleaseNotesEntry[] = [
    // whats-new:draft inserts here (newest first)
    { version: '0.19.0', date: '2026-09-23', languages: ['en'] },
];
